import initWxShare from "@/utils/initWxShare"
import { getActivityDetail, getRegionData, getGradeList } from "@/server/interfaces"
import deepClone from "@/utils/deepClone"
import router from "@/router"
import { FILTER_USER_FORM } from "@/dictionary"
import getParamsFromUrl from "@/utils/getParamsFromUrl"

const TAB_AREA_KEY = "AREA"
// const POPULARITY_KEY = "POPULARITY"
// const LATEST_RELEASE_KEY = "LATEST_RELEASE"
// const RECOMMEND_KEY = "RECOMMEND"
const WORKS_TYPE_KEY = "WORKSTYPE"
const VOTE_NO_BEGIN_MSG = "点赞尚未开始，敬请期待"
const VOTE_EXPIRE_MSG = "点赞已截止，感谢您的关注"

const checkActivityData = activityDetail => {
  if (!activityDetail || (activityDetail && activityDetail.activityStatus === "FORBIDDEN" && getParamsFromUrl().type !== "preview")) {
    router.replace("/nothingnessActivity")
    return false
  } else {
    return true
  }
}

export default {
  namespaced: true,
  state: {
    activityId: "",
    activityDetail: {
      id: "",
      activityName: "",
      backgroundPicUrl: "",
      detail: "",
      shareTitle: "",
      shareDesc: "",
      shareIconUrl: "",
      indexNavigations: [],
      defaultOptions: [],
      activityCategorys: {},
      worksTypes: [],
      submitWorks: false,
      vote: false,
      hiddenVote: "YES",
      notice: "",
      orderNoStatus: "CLOSE"
    },
    activityBannerDesc: {
      banner: "",
      desc: ""
    },
    regionData: [],
    areaPickerRegionData: [],
    activityCategorys: [],
    worksTypesList: [],
    shareInfo: {
      title: " ",
      desc: `“南方+”创造更多价值！`,
      link: window.location.href,
      imgUrl: "https://static.nfapp.southcn.com/app/nanfang_logo.png"
    },
    gradeList: [],
    contributeDefaultOptions: []
  },
  getters: {
    regionData: state => state.regionData,
    areaPickerRegionData: state => state.areaPickerRegionData,
    indexNavigations: state => state.activityDetail.indexNavigations,
    activityCategorys: state => state.activityCategorys,
    defaultOptions: state => state.activityDetail.defaultOptions,
    defaultOpt: state => state.activityDetail.defaultOpt,
    backgroundPicUrl: state => state.activityDetail.backgroundPicUrl,
    activityId: state => state.activityId,
    activityDetails: state => state.activityDetail.detail,
    activityName: state => state.activityDetail.activityName,
    activityDetailDesc: state => state.activityDetail,
    worksTypes: state => state.worksTypesList,
    allWorksTypes: state => state.activityDetail.worksTypes,
    activityBannerDesc: state => {
      let desc = state.activityBannerDesc.desc
      desc = desc.replace(/\n/g, "<p style='margin-bottom: 0.46rem;'></p>")
      state.activityBannerDesc.desc = desc
      return state.activityBannerDesc
    },
    shareInfo: state => state.shareInfo,
    aliNvcValStatus: state => state.activityDetail.aliNvcValStatus,
    gradeList: state => state.gradeList,
    contributeStatus: state => state.activityDetail.submitWorks,
    praiseStatus: state => state.activityDetail.vote,
    hidePraise: state => state.activityDetail.hiddenVote === "YES",
    voteErrorMsg: state => {
      const voteBeginTime = new Date(state.activityDetail.voteBeginTime.replace(/-/g, "/")).getTime()
      const voteEndTime = new Date(state.activityDetail.voteEndTime.replace(/-/g, "/")).getTime()
      const nowTime = new Date().getTime()
      const noBeginFunc = () => nowTime < voteBeginTime
      const expireFunc = () => nowTime > voteEndTime
      const voteMap = new Map()
      voteMap.set(noBeginFunc, VOTE_NO_BEGIN_MSG)
      voteMap.set(expireFunc, VOTE_EXPIRE_MSG)
      const result = {
        status: "success",
        msg: "正常"
      }
      voteMap.forEach((msg, key) => {
        if (key()) {
          result.msg = msg
          result.status = "error"
        }
      })
      return result
    },
    singleShareDesc: state => state.activityDetail.singleShareDesc || "",
    contributeDefaultOptions: state => state.contributeDefaultOptions,
    contributeInformation: state => {
      let contributeInformation = state.activityDetail.notice || ""
      return contributeInformation.replace(/[\n\r]/g, `<br />`)
    }
  },
  mutations: {
    setShareInfo(state, shareInfo) {
      state.shareInfo = Object.assign({}, state.shareInfo, shareInfo)
    },
    setActivityId(state, activityId) {
      state.activityId = activityId
      window.sessionStorage.setItem("NFPLUS_YOUNGREPORTER_ACTIVITY_ID", activityId)
    },
    setActivityDetail(state, activityDetail) {
      activityDetail.detail = activityDetail.detail.replace(/\n/g, "<p style='margin-bottom: 0.46rem;'></p>")
      state.activityDetail = activityDetail
    },
    setRegionData(state, regionData) {
      const dataLevel = 3
      const resolveRegionData = (key = "childOrg", parentArr = regionData) => {
        if (parentArr && Array.isArray(parentArr) && parentArr.length > 0) {
          parentArr.forEach(item => {
            if (item.children && Array.isArray(item.children) && item.children.length > 0) {
              item[key] = item.children.slice(0)
              resolveRegionData("childOrg", item.children)
            } else {
              let currentLevel = 1
              let currentParent = item
              while (dataLevel > currentLevel) {
                currentParent.childOrg = [
                  {
                    name: ""
                  }
                ]
                currentParent = currentParent["childOrg"][0]
                currentLevel++
              }
            }
          })
        }
      }
      resolveRegionData("childOrg", regionData)
      state.regionData = regionData
    },
    setAreaPickerRegionData(state, regionData) {
      const extraAreaArr = ["其他"]
      const areaPickerRegionData = deepClone(regionData)
      const allArea = {
        name: "全部",
        isAll: true,
        children: [
          {
            name: "全部城市",
            isAll: true,
            children: [
              {
                name: "全部区县",
                isAll: true
              }
            ]
          }
        ]
      }
      areaPickerRegionData.forEach(item => {
        const allPickerChildren = {
          name: "全部城市",
          isAll: true,
          children: [
            {
              name: "全部区县",
              isAll: true
            }
          ]
        }
        const isExtraArea = extraAreaArr.includes(item.name)
        if (!isExtraArea) {
          item.children.forEach(childItem => {
            const allDistrict = {
              name: "全部区县",
              isAll: true
            }
            if (childItem.children && Array.isArray(childItem.children)) {
              childItem.children.unshift(allDistrict)
            }
          })
          item.children.unshift(allPickerChildren)
        }
      })
      areaPickerRegionData.push(allArea)
      const resolveRegionData = (key = "childOrg", parentArr = regionData) => {
        if (parentArr && Array.isArray(parentArr) && parentArr.length > 0) {
          parentArr.forEach(item => {
            if (item.children && Array.isArray(item.children) && item.children.length > 0) {
              item[key] = item.children.slice(0)
              resolveRegionData("childOrg", item.children)
            }
          })
        }
      }
      resolveRegionData("childOrg", areaPickerRegionData)
      state.areaPickerRegionData = areaPickerRegionData
    },
    setActivityCategorys(state, activityCategorys) {
      state.activityCategorys = activityCategorys
        .filter(item => item.display === "YES")
        .map(item => {
          return {
            label: item.name,
            ...item
          }
        })
      state.activityCategorys.unshift({
        label: "全部活动",
        id: "",
        isAll: true
      })
    },
    // @TODO 待完善
    setWorksType(state) {
      if (state.activityDetail.worksTypes) {
        state.worksTypesList = state.activityDetail.worksTypes
          .filter(item => item.display === "YES")
          .map(item => {
            return {
              label: item.typeName,
              ...item
            }
          })
        state.worksTypesList.unshift({
          label: "全部",
          id: "",
          typeId: "",
          isAll: true
        })
      }
    },
    refreshActivityBannerDesc(state, activityItem) {
      const activityBannerDesc = {
        banner: state.activityDetail.backgroundPicUrl,
        desc: state.activityDetail.detail
      }
      if (activityItem && activityItem.activityPicUrl && activityItem.activityDesc) {
        activityBannerDesc.banner = activityItem.activityPicUrl
        activityBannerDesc.desc = activityItem.activityDesc
      }
      state.activityBannerDesc = Object.assign({}, state.activityBannerDesc, activityBannerDesc)
    },
    getGradeList(state, gradeList) {
      state.gradeList = gradeList
    },
    setContributeDefaultOptions(state, defaultOptions) {
      const contributeDefaultOptions = []
      const defaultOptionsMap = {}
      defaultOptions.forEach(option => {
        defaultOptionsMap[option] = 1
      })
      Object.keys(FILTER_USER_FORM).forEach(key => {
        if (defaultOptionsMap[key]) {
          contributeDefaultOptions.push(key)
        }
      })
      state.contributeDefaultOptions = contributeDefaultOptions
    }
  },
  actions: {
    updateShareInfo({ state, dispatch }, info) {
      let zid = info.zid
      let url = state.shareInfo.link
      let u = new URL(url)
      if (!u.searchParams.get("zid")) {
        u.searchParams.append("zid", zid)
      }
      state.shareInfo = Object.assign({}, state.shareInfo, {
        link: u.href
      })
      dispatch("initShareInfo")
    },
    initWxShare({ rootState }) {
      const isWx = rootState.systemInfo.isWx
      if (!isWx) return
      const shareOptions = { ...rootState.activityInfo.shareInfo }
      initWxShare(shareOptions)
    },
    initNfPluseShare({ rootState }) {
      const isNfPlus = rootState.systemInfo.isNfPlus
      if (!isNfPlus) return
      const shareInfo = rootState.activityInfo.shareInfo
      const nfPlusShareInfo = {
        shareTitle: shareInfo.title,
        shareIcon: shareInfo.imgUrl,
        shareDesc: shareInfo.desc,
        shareUrl: shareInfo.link
      }
      window.nfplusJsbridge.setShareInfo(nfPlusShareInfo)
    },
    initShareInfo({ dispatch }) {
      dispatch("initWxShare")
      dispatch("initNfPluseShare")
    },
    async getActivityInfo({ dispatch, rootState }, params) {
      const activityId = rootState.activityInfo.activityId
      if (!activityId) {
        window.console.error("请传入正确的活动id")
        return false
      }
      const acitvityParams = {
        params: {
          id: activityId
        },
        ...params
      }
      const activityDetail = await getActivityDetail(acitvityParams)
      if (!checkActivityData(activityDetail)) return false
      dispatch("resolveActivityInfo", { activityDetail, params })
      return true
    },
    resolveActivityInfo({ commit, dispatch }, { activityDetail, params }) {
      params = params || {}
      if (!checkActivityData(activityDetail)) return false
      commit("setActivityId", activityDetail.id)
      const shareInfo = {
        title: activityDetail.shareTitle,
        desc: activityDetail.shareDesc,
        link: window.location.href,
        imgUrl: activityDetail.shareIconUrl
      }
      commit("setContributeDefaultOptions", activityDetail.defaultOptions)
      activityDetail.defaultOptions = activityDetail.defaultOptions.filter(option => !FILTER_USER_FORM[option])
      commit("setActivityDetail", activityDetail)
      if (activityDetail.activityCategorys && Array.isArray(activityDetail.activityCategorys)) {
        commit("setActivityCategorys", activityDetail.activityCategorys)
        const defaultActivity = activityDetail.activityCategorys.find(item => item.isDefault && item.display === "YES")
        commit("refreshActivityBannerDesc", defaultActivity)
      }
      const hasWorktType = activityDetail.indexNavigations.indexOf(WORKS_TYPE_KEY) > -1
      if (hasWorktType) {
        commit("setWorksType")
      }
      const hasAreaTab = activityDetail.indexNavigations.indexOf(TAB_AREA_KEY) > -1
      if (hasAreaTab) {
        dispatch("getRegionData")
      }
      if (!params.notInitShare) {
        commit("setShareInfo", shareInfo)
        dispatch("initShareInfo")
      }
    },
    async getRegionData({ commit }) {
      const regionData = await getRegionData()
      commit("setRegionData", regionData)
      commit("setAreaPickerRegionData", regionData)
    },
    async getGradeList({ state, commit }) {
      if (state.gradeList.length > 0) return
      const gradeList = await getGradeList({ showLoading: true })
      commit("getGradeList", gradeList)
    }
  }
}
